import { Box, Typography } from '@mui/material';
import InputForm from '../../InputT';
import SearInputM from '../../SearchModal';
import Params from '../../../Types/ParamsPicklist';
import SearchModal from '../../SearchModal';
import { Form } from 'antd';
import CheckboxF from '../../ChexBox';

let searchCaodeArete: Params = { CodeAgence: '', Table: "TYPADR", Colonne1: "CODTYPE", Colonne2: "LIBELL1", Colagence: '001', Choix: 22 }
let searchAgiosImpeye: Params = { CodeAgence: 'PAYS', Table: "LIB", Colonne1: "CODLIB", Colonne2: "LIBELL", Colagence: 'RUBRIQ', Choix: 22 }
let searchVille: Params = { CodeAgence: 'Ville', Table: "LIB", Colonne1: "CODLIB", Colonne2: "Libell", Colagence: 'RUBRIQ', Choix: 22 }


const Tab3 = (props: { form?: any }) => {
    return (
        <div className='tabItem'>
            <Box fontStyle="inherit" className='border-left border' width={"85%"} position={"absolute"}>
                <Box style={{ display: 'flex' }}   >
                    <Box fontStyle="inherit" className='border-left '>
                        <CheckboxF width={20} name='ICDVCH' label='Délivrance chéquier?' />
                        <CheckboxF width={20} name='REGPT' label='Regroupement ?' />
                        <CheckboxF width={20} name='isPaieSms' label='Frais  SMS?' />
                    </Box>

                    <Box fontStyle="inherit" className='border-left '>
                        <CheckboxF width={20} label={"Compte Bloquée à la Caisse ?"} name={"IsBloqCai"} />
                        <CheckboxF width={20} label={"Compte Bloquée en backoffice ? "} name={"IsBloqSai"} />
                        <CheckboxF width={20} label={"Interagence Bloquéé à la Caisse"} name={"IsInterAgceBloCai"} />

                        {/* <Box fontStyle="inherit" className='border-left '>
                            <SearchModal width={9} form={props.form} Titre={""} label={"Sens du solde"} name={""} Parametre={searchCaodeArete} />
                        </Box> */}
                    </Box>
                    <Box fontStyle="inherit" className='border-left '>
                        <CheckboxF label={"Interagence Bloquéé en Backoffice"} name={"IsInterAgceBloSai"} />
                    </Box>

                </Box>
            </Box>

        </div>

    );

}

export default Tab3;